import { createEntityAdapter, EntityId, EntityState } from "@reduxjs/toolkit";
import { Dossier } from "types/Dossier";

export const dossierAdapter = createEntityAdapter<Dossier>();

export interface CaseManagementState {
    dossiers: EntityState<Dossier, EntityId>;
    totalDossiers?: number;
    isLoadingDossiers: boolean;
    errorLoadingDossiers?: string;
}

export const initialState: CaseManagementState = {
    dossiers: dossierAdapter.getInitialState(),
    isLoadingDossiers: false,
};
